"use client";

import type { ReactNode } from "react";
import { StatusPageLayoutContext } from "./StatusPageLayoutContext";

/** Status pages inside an existing shell use its page structure and footer. */
export const StatusPageLayout = ({ children }: { children: ReactNode }) => (
  <StatusPageLayoutContext value={true}>{children}</StatusPageLayoutContext>
);
